export default "/images/buyers-bg.png?1644d49f5816c016c378176d31aaa874";